<div class="wrapper">
  <div class="error">
    {{error}}
  </div>
</div>
